import { render, staticRenderFns } from "./AsyncPagination.vue?vue&type=template&id=65cfb99e&scoped=true&"
import script from "./AsyncPagination.vue?vue&type=script&lang=js&"
export * from "./AsyncPagination.vue?vue&type=script&lang=js&"
import style0 from "./AsyncPagination.vue?vue&type=style&index=0&id=65cfb99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfb99e",
  null
  
)

export default component.exports